module.exports = __webpack_public_path__ + "img/card.1063eaee.png";